export const validateCPF = (cpf: string) => {
  var Soma = 0;
  var Resto;
  if (cpf == "00000000000") return false;

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(cpf.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(cpf.substring(10, 11))) return false;
  return true;
};

export const validateCNPJ = (cnpj: string) => {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj == "") return false;

  if (cnpj.length != 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  // Valida DVs
  var tamanho = cnpj.length - 2;
  var numeros = cnpj.substring(0, tamanho);
  var digitos = cnpj.substring(tamanho);
  var soma = 0;
  var pos = tamanho - 7;
  var resultado;
  for (var i = tamanho; i >= 1; i--) {
    soma = soma + parseInt(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  // @ts-ignore
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma = soma + parseInt(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  // @ts-ignore
  if (resultado != digitos.charAt(1)) return false;

  return true;
};

export const validateEmail = (email: string) => {
  return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
};

export const validateCellphone = (phone: string) => {
  if (phone.length !== 11) return false;

  if (phone.slice(2, 3) != "9") return false;
};

// unformatted uuid (without -)
export const validateRandomKey = (key: string) => {
  if (key.length !== 32) return false;
  return true;
};

export const validateDDD = (ddd: string): boolean => {
  // Remove todos os caracteres não numéricos
  const numericDigits = ddd.replace(/\D/g, "");

  // Verifica se restaram exatamente dois dígitos numéricos
  return /^\d{2}$/.test(numericDigits);
};

export const validateCellphoneDigit = (phone: string): boolean => {
  // Remove espaços em branco e caracteres especiais
  const cleanedPhone = phone.replace(/[-\s()]/g, "");

  // Verifica se o número de telefone tem 9 dígitos (nao considerando DDD)
  if (cleanedPhone.length !== 9) {
    return false;
  }

  // Extrai os dois primeiros dígitos como o DDD
  const ddd = cleanedPhone.slice(0, 2);

  // Valida o DDD usando a função separada
  if (!validateDDD(ddd)) {
    return false;
  }
  // Verifica se o primeiro dígito é "9"
  if (cleanedPhone[0] !== "9") {
    return false;
  }

  // Se todas as condições passarem, o número é considerado válido
  return true;
};

export const validateNumberphone = (phone: string): boolean => {
  // Remove espaços em branco e caracteres especiais
  const cleanedPhone = phone.replace(/[-\s()]/g, "");

  // Verifica se o número de telefone tem 9 dígitos
  if (cleanedPhone.length !== 9) {
    return false;
  }

  // Verifica se o primeiro dígito do número é "9"
  if (cleanedPhone[0] !== "9") {
    return false;
  }

  // Se todas as condições passarem, o número é considerado válido
  return true;
};

// date in dd/mm/yyyy
export const validateDate = (date: string) => {
  // First check for the pattern
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) return false;

  // Parse the date parts to integers
  var parts = date.split("/");
  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
    monthLength[1] = 29;

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
};
